<app-base-modal
  [open]="open"
  [size]="'xl'"
  [title]="questionText || 'Reviewer evidence'"
  (openChange)="openChange.emit($event)"
>
  <!-- Legend: one swatch + name per reviewer, with a jump button or no-evidence note. -->
  <div
    class="flex flex-wrap items-center gap-4 px-1 pb-3 text-sm text-slate-700"
    data-testid="reviewer-legend"
  >
    <div class="flex items-center gap-2">
      <span
        class="inline-block w-3.5 h-3.5 rounded-sm border border-slate-300"
        data-testid="swatch-a"
        [style.backgroundColor]="REVIEWER_A_COLOR"
      ></span>
      <span class="font-medium">{{ reviewerA.reviewerName }}</span>
      @if (aHasBoxes()) {
        <button
          class="btn-secondary text-xs px-2 py-0.5"
          [disabled]="loading() || loadFailed() || pages().length === 0"
          (click)="jumpToFirstBox('A')"
          data-testid="jump-a"
        >
          Jump to first box
        </button>
      } @else {
        <span class="text-xs italic text-slate-500" data-testid="no-evidence-a"
          >(no evidence for this question)</span
        >
      }
    </div>
    <div class="flex items-center gap-2">
      <!-- Mirrors reviewer B's hatched overlay style: dashed border + diagonal stripes. -->
      <span
        class="inline-block w-3.5 h-3.5 rounded-sm border border-dashed"
        data-testid="swatch-b"
        [style.borderColor]="REVIEWER_B_COLOR"
        [style.background]="
          'repeating-linear-gradient(45deg, transparent 0 2px, ' + REVIEWER_B_COLOR + ' 2px 3.5px)'
        "
      ></span>
      <span class="font-medium">{{ reviewerB.reviewerName }}</span>
      @if (bHasBoxes()) {
        <button
          class="btn-secondary text-xs px-2 py-0.5"
          [disabled]="loading() || loadFailed() || pages().length === 0"
          (click)="jumpToFirstBox('B')"
          data-testid="jump-b"
        >
          Jump to first box
        </button>
      } @else {
        <span class="text-xs italic text-slate-500" data-testid="no-evidence-b"
          >(no evidence for this question)</span
        >
      }
    </div>
  </div>

  @if (loadFailed()) {
    <div
      class="px-3 py-2 mb-2 bg-red-50 border border-red-200 text-red-700 text-sm rounded"
      data-testid="viewer-load-failed"
    >
      The PDF failed to load in the viewer.
    </div>
  }

  <div class="relative h-[70vh] overflow-hidden bg-slate-100 rounded border border-slate-200">
    <app-cad-pdf-viewer
      #viewer
      [showZoomBar]="true"
      (pageRendered)="onPageRendered($event)"
      (loadFailed)="onViewerLoadFailed()"
    />
    @for (p of pages(); track p) {
      @if (geometryFor(p); as geom) {
        @if (pageElementFor(p); as pageEl) {
          <!-- Reviewer A read-only overlay layer: solid stroke, plain tint. -->
          <ng-container
            appClaimAnnotatorOverlay
            [overlayStore]="sourceA"
            [overlayClaimSet]="claimSource"
            [overlayReadOnly]="true"
            [overlayClaimFilter]="claimFilter"
            [overlayBoxStyle]="'solid'"
            [overlayHighlight]="highlightA()"
            [overlayPageNumber]="p"
            [overlayDocumentId]="documentId"
            [overlayGeometry]="geom"
            [overlayPageElement]="pageEl"
          ></ng-container>
          <!-- Reviewer B read-only overlay layer: dashed stroke, diagonal hatch, so both
               reviewers stay distinguishable even when boxes overlap exactly. -->
          <ng-container
            appClaimAnnotatorOverlay
            [overlayStore]="sourceB"
            [overlayClaimSet]="claimSource"
            [overlayReadOnly]="true"
            [overlayClaimFilter]="claimFilter"
            [overlayBoxStyle]="'hatched'"
            [overlayHighlight]="highlightB()"
            [overlayPageNumber]="p"
            [overlayDocumentId]="documentId"
            [overlayGeometry]="geom"
            [overlayPageElement]="pageEl"
          ></ng-container>
        }
      }
    }
  </div>
</app-base-modal>
